<template>
  <div class="container-fluid">

    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Consulta de Visitas.</span>
                <br />
                <span class="navigation">Consulta > Monitoramento de Visitas</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body p-0 mt-4 mb-4">
          <label style="font-weight: bold; font-size: 12px">Filtro Pesquisa:</label>
          <div class="row">
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar id="dataPesquisaInicial" name="dataPesquisaInicial" v-model="dataPesquisaInicial" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Inicial" @keyup.enter="validarPesquisa" v-maska="'##/##/####'" />
              </span>
            </div>
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar id="dataPesquisaFinal" name="dataPesquisaFinal" v-model="dataPesquisaFinal" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Final" @keyup.enter="validarPesquisa" v-maska="'##/##/####'" />
              </span>
            </div>
            <div class="col-md-4 col-lg-4 mb-3">
              <span class="p-fluid">
                <AutoComplete 
                  dropdown
                  field="label"
                  placeholder="Pesquisar Usuário"
                  v-model="selectedUsuario"
                  :suggestions="filteredUsuarios" 
                  @complete="searchUsuario($event)" 
                  @keyup.enter="validarPesquisa"
                />
              </span>
            </div>
            <div class="col-md-2 col-lg-1">
              <Button @click="validarPesquisa" alt="Pesquisar" label="Pesquisar" type="button" class="p-button-primary mr-2" icon="pi pi-search" 
                :disabled="loading" />
            </div>
          </div>

        </div>
      </div>  
    </div>

    <TabView class="mb-4">

      <TabPanel header="Web">

        <div class="d-flex">
          <div class="p-2 w-100" style="padding-left: 0 !important;">
            <Card class="">
              <template #title>{{ acessos.length }}</template>
              <template #subtitle>Acessos</template>
            </Card>
          </div>
          <div class="p-2 w-100">
            <Card>
              <template #title>{{ visitantes.length }}</template>
              <template #subtitle>Visitantes</template>
            </Card>
          </div>
          <div class="p-2 w-100">
            <Card>
              <template #title>{{ paginas.length }}</template>
              <template #subtitle>Páginas acessadas</template>
            </Card>
          </div>
          <div class="p-2 w-100" style="padding-right: 0 !important;">
            <Card>
              <template #title>{{ online.length }}</template>
              <template #subtitle>Online</template>
            </Card>
          </div>
        </div>

        <div class="row pr-3 pl-3">
          <Card class="w-100 mb-4 mt-4">
            <template #title>Usuáros Online</template>
            <template #content>
              <DataTable class="mh-0 mb-10" :value="online" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
                <template #empty>Nenhum resultado encontrado.</template>
                <Column field="nome" header="Usuário" bodyStyle="text-align:center" headerStyle="width: 10em"></Column>
                <Column field="dataLoginFormat" header="Data Login" bodyStyle="text-align:center"></Column>
                <Column field="duracao" header="Tempo Online" bodyStyle="text-align:rigth"></Column>
                <Column field="paginaAtual" header="Página Atual" bodyStyle="text-align:left"></Column>
              </DataTable>
            </template>
          </Card>
        </div>

        <div class="row pr-3 pl-3">
          <Card class="w-100 mb-4">
            <template #title>Páginas Acessadas</template>
            <template #content>
              <DataTable class="mh-0 mb-10" :value="paginas" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
                <template #empty>Nenhum resultado encontrado.</template>
                <Column field="pagina" header="Página" bodyStyle="text-align:center" headerStyle="width: 10em"></Column>
              </DataTable>
            </template>
          </Card>
        </div>
        
        <div class="row pr-3 pl-3">
          <Card class="w-100 mb-4">
            <template #title>Acessos</template>
            <template #content>
              <DataTable class="mh-0 mb-10" :value="acessos" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
                <template #empty>Nenhum resultado encontrado.</template>
                <Column field="nome" header="Usuário" bodyStyle="text-align:center" headerStyle="width: 10em"></Column>
                <Column field="dataLoginFormat" header="Data Login" bodyStyle="text-align:rigth"></Column>
                <Column field="dataLogoutFormat" header="Data Logout" bodyStyle="text-align:rigth"></Column>
                <Column field="duracao" header="Duração" bodyStyle="text-align:rigth"></Column>
              </DataTable>
            </template>
          </Card>
        </div>

      </TabPanel>

      <TabPanel header="Chat">

        <div class="d-flex">
          <div class="p-2 w-100" style="padding-left: 0 !important;">
            <Card class="">
              <template #title>{{ acessosChat.length }}</template>
              <template #subtitle>Acessos</template>
            </Card>
          </div>
          <div class="p-2 w-100">
            <Card>
              <template #title>{{ visitantesChat.length }}</template>
              <template #subtitle>Visitantes</template>
            </Card>
          </div>
          <div class="p-2 w-100">
            <Card>
              <template #title>{{ mensagensRespondidasChat.length }}</template>
              <template #subtitle>Mensagens Respondidas</template>
            </Card>
          </div>
          <div class="p-2 w-100">
            <Card>
              <template #title>{{ mensagensNaoRespondidasChat.length }}</template>
              <template #subtitle>Mensagens <b>Não</b> Respondidas</template>
            </Card>
          </div>
          <div class="p-2 w-100" style="padding-right: 0 !important;">
            <Card>
              <template #title>{{ onlineChat.length }}</template>
              <template #subtitle>Online</template>
            </Card>
          </div>
        </div>

        <div class="row pr-3 pl-3">
          <Card class="w-100 mb-4 mt-4">
            <template #title>Usuáros Online</template>
            <template #content>
              <DataTable class="mh-0 mb-10" :value="onlineChat" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
                <template #empty>Nenhum resultado encontrado.</template>
                <Column field="nome" header="Usuário" bodyStyle="text-align:center" headerStyle="width: 10em"></Column>
                <Column field="dataLoginFormat" header="Data Login" bodyStyle="text-align:center"></Column>
                <Column field="duracao" header="Tempo Online" bodyStyle="text-align:rigth"></Column>
              </DataTable>
            </template>
          </Card>
        </div>

        <div class="row pr-3 pl-3">
          <Card class="w-100 mb-4">
            <template #title>Mensagens Respondidas</template>
            <template #content>
              <DataTable class="mh-0 mb-10" :value="mensagensRespondidasChat" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
                <template #empty>Nenhum resultado encontrado.</template>
                <Column field="remetente" header="Remetente" bodyStyle="text-align:left" headerStyle="width: 10em"></Column>
                <Column field="destinatario" header="Destinatário" bodyStyle="text-align:left" headerStyle="width: 10em"></Column>
                <Column field="mensagem" header="Mensagem" bodyStyle="text-align:left" headerStyle="width: 10em"></Column>
              </DataTable>
            </template>
          </Card>
        </div>

        <div class="row pr-3 pl-3">
          <Card class="w-100 mb-4">
            <template #title>Mensagens Não Respondidas</template>
            <template #content>
              <DataTable class="mh-0 mb-10" :value="mensagensNaoRespondidasChat" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
                <template #empty>Nenhum resultado encontrado.</template>
                <Column field="remetente" header="Remetente" bodyStyle="text-align:left" headerStyle="width: 10em"></Column>
                <Column field="destinatario" header="Destinatário" bodyStyle="text-align:left" headerStyle="width: 10em"></Column>
                <Column field="mensagem" header="Mensagem" bodyStyle="text-align:left" headerStyle="width: 10em"></Column>
              </DataTable>
            </template>
          </Card>
        </div>
        
        <div class="row pr-3 pl-3">
          <Card class="w-100 mb-4">
            <template #title>Acessos</template>
            <template #content>
              <DataTable class="mh-0 mb-10" :value="acessosChat" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
                <template #empty>Nenhum resultado encontrado.</template>
                <Column field="nome" header="Usuário" bodyStyle="text-align:center" headerStyle="width: 10em"></Column>
                <Column field="dataLoginFormat" header="Data Login" bodyStyle="text-align:rigth"></Column>
                <Column field="dataLogoutFormat" header="Data Logout" bodyStyle="text-align:rigth"></Column>
                <Column field="duracao" header="Duração" bodyStyle="text-align:rigth"></Column>
              </DataTable>
            </template>
          </Card>
        </div>
        
      </TabPanel>

    </TabView>

  </div>
</template>
<script>
import MonitoramentoVisitaService from "@/services/nfse/monitoramento.visita.service";
import moment from "moment";
import CustomCalendar from "../components/global/CustomCalendar.vue";

export default {
  name: "MonitoramentoVisita",
  components: {
    CustomCalendar
  },
  data() {
    return {
      loading: false,
      dataPesquisaInicial: new Date(),
      dataPesquisaFinal: new Date(),
      selectedUsuario: null,
      filteredUsuarios: [],

      acessos: [],
      visitantes: [],
      paginas: [],
      online: [],

      acessosChat: [],
      visitantesChat: [],
      mensagensRespondidasChat: [],
      mensagensNaoRespondidasChat: [],
      onlineChat: [],
    };
  },

  created() {

  },

  mounted() {
    this.pesquisar();
  },

  methods: {

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    searchUsuario(event) {
      setTimeout(async () => {
        const data = await MonitoramentoVisitaService.getUsuarioFiltro(event.query);
        this.filteredUsuarios = data.map(v => ({label: `${v.nome} ( Nome Acesso: ${v.nomeAcesso} ) ( Documento: ${v.documento} )`, id: v.idUsuario}));
      }, 550);
    },

    pesquisar() {
      this.processando(true);

      this.getAcessos();
      this.getVisitantes();
      this.getPaginas();
      this.getOnline();

      this.getAcessosChat();
      this.getVisitantesChat();
      this.getOnlineChat();
      this.getMensagensRespondidasChat();
      this.getMensagensNaoRespondidasChat();

      this.processando(false);
    },

    validarPesquisa() {
      var msg = null;
      if (!this.dataPesquisaInicial) {
        msg = "É necessário informar a Data Inicial!";
      } else if (!this.dataPesquisaFinal) {
        msg = "É necessário informar a Data Final!";
      } else if (this.dataPesquisaInicial > this.dataPesquisaFinal) {
        msg = "A Data Inicial deve ser menor ou igual a Data Final!";
      } else if (moment(this.dataPesquisaFinal).diff(moment(this.dataPesquisaInicial), 'hours') > 168) {
        msg = "O período para consulta não pode ser maior que uma semana!";
      }

      if (!msg) {
        this.pesquisar();
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },

    async getAcessos() {
      this.processando(true);
      const idUsuarioFiltro = this.selectedUsuario ? this.selectedUsuario.id : null;
      await MonitoramentoVisitaService.getAcessos(
        {idUsuarioFiltro: idUsuarioFiltro, dataPesquisaInicial: this.dataPesquisaInicial, dataPesquisaFinal: this.dataPesquisaFinal}
      ).then(
        data => {
          this.acessos = data.map(v => ({
            ...v,
            dataLoginFormat: moment(v.horaInicial).format('DD/MM/YYY HH:mm:ss'),
            dataLogoutFormat: moment(v.horaAtual).format('DD/MM/YYY HH:mm:ss'),
            duracao: this.duracao(v.horaInicial,v.horaAtual),
          }));
        },
        error => {
          console.log("Houve um erro ao buscar acessos!");
          if (error.response) {
            console.log(error.response.data);
          }
        }
      );
      this.processando(false);
    },

    async getVisitantes() {
      this.processando(true);
      await MonitoramentoVisitaService.getVisitantes(
        {dataPesquisaInicial: this.dataPesquisaInicial, dataPesquisaFinal: this.dataPesquisaFinal}
      ).then(
        data => {
          this.visitantes = data;
        },
        error => {
          console.log("Houve um erro ao buscar visitantes!");
          if (error.response) {
            console.log(error.response.data);
          }
        }
      );
      this.processando(false);
    },

    async getPaginas() {
      this.processando(true);
      const idUsuarioFiltro = this.selectedUsuario ? this.selectedUsuario.id : null;
      await MonitoramentoVisitaService.getPaginas(
        {idUsuarioFiltro: idUsuarioFiltro, dataPesquisaInicial: this.dataPesquisaInicial, dataPesquisaFinal: this.dataPesquisaFinal}
      ).then(
        data => {
          this.paginas = data;
        },
        error => {
          console.log("Houve um erro ao buscar paginas!");
          if (error.response) {
            console.log(error.response.data);
          }
        }
      );
      this.processando(false);
    },

    async getOnline() {
      this.processando(true);
      await MonitoramentoVisitaService.getOnline(
        {dataPesquisaInicial: this.dataPesquisaInicial, dataPesquisaFinal: this.dataPesquisaFinal}
      ).then(
        
        data => {
          this.online = data.map(v => ({
            ...v,
            dataLoginFormat: moment(v.horaInicial).format('DD/MM/YYY HH:mm:ss'),
            dataAtualFormat: moment(v.horaAtual).format('DD/MM/YYY HH:mm:ss'),
            duracao: this.duracao(v.horaInicial,v.horaAtual),
          }));
        },
        error => {
          console.log("Houve um erro ao buscar os online!");
          if (error.response) {
            console.log(error.response.data);
          }
        }
      );
      this.processando(false);
    },


    async getAcessosChat() {
      this.processando(true);
      const idUsuarioFiltro = this.selectedUsuario ? this.selectedUsuario.id : null;
      await MonitoramentoVisitaService.getAcessosChat(
        {idUsuarioFiltro: idUsuarioFiltro, dataPesquisaInicial: this.dataPesquisaInicial, dataPesquisaFinal: this.dataPesquisaFinal}
      ).then(
        data => {
          this.acessosChat = data.map(v => ({
            ...v,
            dataLoginFormat: moment(v.dataVigenciaInicial).format('DD/MM/YYYY HH:mm:ss'),
            dataLogoutFormat: moment(v.dataVigenciaFinal).format('DD/MM/YYYY HH:mm:ss'),
            duracao: this.duracao(v.dataVigenciaInicial,v.dataVigenciaFinal),
          }));

        },
        error => {
          console.log("Houve um erro ao buscar acessos!");
          if (error.response) {
            console.log(error.response.data);
          }
        }
      );
      this.processando(false);
    },

    async getVisitantesChat() {
      this.processando(true);
      await MonitoramentoVisitaService.getVisitantesChat(
        {dataPesquisaInicial: this.dataPesquisaInicial, dataPesquisaFinal: this.dataPesquisaFinal}
      ).then(
        data => {
          this.visitantesChat = data;
        },
        error => {
          console.log("Houve um erro ao buscar visitantes Chat!");
          if (error.response) {
            console.log(error.response.data);
          }
        }
      );
      this.processando(false);
    },

    async getMensagensRespondidasChat() {
      this.processando(true);
      const idUsuarioFiltro = this.selectedUsuario ? this.selectedUsuario.id : null;
      await MonitoramentoVisitaService.getMensagensRespondidasChat(
        {idUsuarioFiltro: idUsuarioFiltro, dataPesquisaInicial: this.dataPesquisaInicial, dataPesquisaFinal: this.dataPesquisaFinal}
      ).then(
        data => {
          this.mensagensRespondidasChat = data;
        },
        error => {
          console.log("Houve um erro ao buscar mensagens respondidas Chat!");
          if (error.response) {
            console.log(error.response.data);
          }
        }
      );
      this.processando(false);
    },

    async getMensagensNaoRespondidasChat() {
      this.processando(true);
      const idUsuarioFiltro = this.selectedUsuario ? this.selectedUsuario.id : null;
      await MonitoramentoVisitaService.getMensagensNaoRespondidasChat(
        {idUsuarioFiltro: idUsuarioFiltro, dataPesquisaInicial: this.dataPesquisaInicial, dataPesquisaFinal: this.dataPesquisaFinal}
      ).then(
        data => {
          this.mensagensaNaoRespondidasChat = data;
        },
        error => {
          console.log("Houve um erro ao buscar mensagens não respondidas Chat!");
          if (error.response) {
            console.log(error.response.data);
          }
        }
      );
      this.processando(false);
    },

    async getOnlineChat() {
      this.processando(true);
      await MonitoramentoVisitaService.getOnlineChat(
        {dataPesquisaInicial: this.dataPesquisaInicial, dataPesquisaFinal: this.dataPesquisaFinal}
      ).then(
        
        data => {
          this.onlineChat = data.map(v => {
            console.log("gggg",v, moment().format())
          
          return ({
            ...v,
            dataLoginFormat: moment(v.dataVigenciaInicial).format('DD/MM/YYYY HH:mm:ss'),
            duracao: this.duracao(v.dataVigenciaInicial, moment().format()),
          }
        )
    });
        },
        error => {
          console.log("Houve um erro ao buscar os online Chat!");
          if (error.response) {
            console.log(error.response.data);
          }
        }
      );
      this.processando(false);
    },


    duracao(dataInicial, dataFinal) {
      const diferenca = moment(dataFinal).diff(moment(dataInicial));
      const duracao = moment.duration(diferenca);

      // let anos = Math.floor(duracao.asYears());
      // let meses = Math.floor(duracao.asMonths()) % 12;
      const dias = Math.floor(duracao.asDays()) % 30;
      const horas = duracao.hours();
      const minutos = duracao.minutes();
      const segundos = duracao.seconds();
      
      let retTempo = `${minutos} minutos e ${segundos} segundos`;
      retTempo = (horas > 0) ? `${horas} horas, ${retTempo}` : retTempo;
      retTempo = (dias > 0) ? `${dias} dias, ${retTempo}` : retTempo;

      return retTempo;
    },

  },

  computed: {
  
  }
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}
:deep(.p-datatable-auto-layout>.p-datatable-wrapper) {
  min-height: 0 !important;
}
</style>